import React, { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/apiClient";
import ProductCard from "@/components/ProductCard";

const CATEGORIES = [
  { id: "all",      label: "All" },
  { id: "bouquets", label: "Bouquets" },
  { id: "balloons", label: "Balloons" },
  { id: "sweets",   label: "Sweets" },
  { id: "merch",    label: "Merch" },
  { id: "gifts",    label: "Gifts" },
];

const Shop = () => {
  const [params, setParams] = useSearchParams();
  const active = params.get("category") || "all";
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      const { data } = await api.get("/products");
      setProducts(data);
      setLoading(false);
    })();
  }, []);

  const visible = useMemo(() => {
    if (active === "all") return products;
    return products.filter((p) => p.category === active);
  }, [products, active]);

  const setCategory = (id) => {
    if (id === "all") setParams({});
    else setParams({ category: id });
  };

  const tones = ["pink", "mint", "lav", "cream"];

  return (
    <div className="lf-container py-16 md:py-24" data-testid="shop-page">
      <div className="max-w-3xl">
        <span className="lf-eyebrow">The Shop</span>
        <h1
          className="font-serif mt-4 leading-none"
          style={{ fontSize: "clamp(2.5rem, 6vw, 4.75rem)", fontWeight: 300, color: "var(--lf-ink)" }}
        >
          Everything we make,
          <br />
          <em style={{ color: "var(--lf-gold-deep)" }}>in one quiet place.</em>
        </h1>
      </div>

      <div className="mt-12 flex flex-wrap gap-3" data-testid="shop-filters">
        {CATEGORIES.map((c) => {
          const isActive = active === c.id;
          return (
            <button
              key={c.id}
              data-testid={`shop-filter-${c.id}`}
              onClick={() => setCategory(c.id)}
              className="px-5 py-2.5 text-xs uppercase tracking-[0.2em] transition-colors"
              style={{
                background: isActive ? "var(--lf-gold)" : "white",
                color: isActive ? "white" : "var(--lf-ink)",
                borderRadius: 999,
                border: `1px solid ${isActive ? "var(--lf-gold)" : "var(--lf-border)"}`,
              }}
            >
              {c.label}
            </button>
          );
        })}
      </div>

      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 md:gap-14">
        {loading
          ? Array.from({ length: 6 }).map((_, i) => (
              <div key={i} className="animate-pulse" style={{ aspectRatio: "4 / 5", background: "var(--lf-pink-pale)", borderRadius: 18 }} />
            ))
          : visible.map((p, i) => <ProductCard key={p.id} product={p} tone={tones[i % tones.length]} />)}
      </div>

      {!loading && visible.length === 0 && (
        <p className="mt-16 text-center font-serif text-2xl italic" style={{ color: "var(--lf-ink-soft)" }}>
          Nothing here yet. Check back soon.
        </p>
      )}
    </div>
  );
};

export default Shop;
